import axios from 'axios'

export const updateBetaFactor = (scorecard) =>
    axios.post('advisor/betafactor/update', scorecard)
        .then(({ data }) => data)
